import React from "react";
import MDBox from "shared/ui/Box/MDBox";
import TextField from "@mui/material/TextField";
import usePlanner from "features/planner/state/usePlanner";
import useDeviceType from "hooks/useDeviceType";

export default function NotesEditor() {
  const { programState, updateProgramNotes } = usePlanner();
  const { isLaptop } = useDeviceType();

  const minH = isLaptop ? "140px" : "200px";
  const maxH = isLaptop ? "260px" : "350px";
  const minRows = isLaptop ? 3 : 5;

  const handleNotesChange = (e) => {
    const raw = e.target.value;

    // Dividir en líneas
    let lines = raw.split("\n");

    // Limitar número de líneas
    const maxLines = 15;
    lines = lines.slice(0, maxLines);

    // Limitar caracteres por línea
    const maxChars = 80;
    const sanitizedLines = lines.map((line) =>
      line.length > maxChars ? line.slice(0, maxChars) : line
    );

    // Guardar como string unificado
    updateProgramNotes(sanitizedLines.join("\n"));
  };

  return (
    <MDBox
      sx={{
        width: "100%",
        minHeight: minH,
        maxHeight: maxH,
        overflowY: "auto",
        backgroundColor: "grey.100",
        borderRadius: "12px",
        border: "1px solid",
        borderColor: "grey.300",
        padding: isLaptop ? "10px" : "16px",
        display: "flex",
        flexDirection: "column",
        "&:hover": { backgroundColor: "grey.200", borderColor: "primary.main" },
      }}
    >
      <TextField
        fullWidth
        multiline
        minRows={minRows}
        maxRows={10}
        placeholder="Escribe aquí las notas de la rutina..."
        variant="standard"
        value={programState.notes}
        onChange={handleNotesChange}
        InputProps={{
          disableUnderline: true,
          sx: {
            fontSize: isLaptop ? "0.8rem" : "0.9rem",
            lineHeight: 1.35,
            color: "text.primary",
          },
        }}
      />
    </MDBox>
  );
}
